export { default as TextInput } from './TextInput'
export type { TextInputProps } from './TextInput'
